import { z } from "zod";
import { ReportResourceType } from "../enum.js";

export const createReportSchema = z.object({
	resource_type: z.enum([ReportResourceType.POST, ReportResourceType.COMMENT, ReportResourceType.MESSAGE]),
	resource_id: z.string(),
	reason: z.string().max(500).optional(),
});

export type CreateReportPayload = z.infer<typeof createReportSchema>;
